import React from 'react'

const Manual_acciones_masivas_clientes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Acciones masivas para clientes
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo realizar acciones masivas sobre tus clientes dentro del Dashboard de Clau.io de forma rápida y eficiente.
        </p>
        <iframe
          src="https://scribehow.com/embed/Acciones_masivas_para_clientes__4bwD_nXVRKWtLavJyjJbPw?as=scrollable"
          className="scribe-iframe-general-88"
          width="100%"
          height="6400"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_acciones_masivas_clientes
